"use client";

import { useAuth } from "@/components/AuthProvider";
import SupportUnreadProvider from "@/components/support/SupportUnreadProvider";
import { usePathname } from "next/navigation";

function isNonCustomerAccountArea(pathname: string) {
  return ["/admin", "/business", "/business-auth", "/staff"].some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`)
  );
}

export default function CustomerSupportUnreadBoundary({
  children,
}: {
  children: React.ReactNode;
}) {
  const pathname = usePathname() || "";
  const { role, supportModeActive } = useAuth();

  // Business and admin areas own their unread provider. Keeping them outside
  // this boundary prevents nested contexts and duplicate realtime channels.
  if (isNonCustomerAccountArea(pathname)) return children;

  return (
    <SupportUnreadProvider
      audience="customer"
      enabled={role === "customer" && !supportModeActive}
    >
      {children}
    </SupportUnreadProvider>
  );
}
